import type { JSX } from 'solid-js';

// Loading placeholder — a flat block that breathes (opacity only, behind
// reduced motion; no shimmer). CSS owns the look (`.skeleton`, `ui/_states.scss`);
// callers size it with `height`/`width` or a modifier class (`skeleton--card`).
// Decorative: `aria-hidden` so screen readers skip it (the live region that
// replaces it announces the loaded content).

export type SkeletonProps = {
  readonly height?: string;
  readonly width?: string;
  readonly class?: string;
};

export function Skeleton(props: SkeletonProps): JSX.Element {
  return (
    <div
      class={`skeleton${props.class ? ` ${props.class}` : ''}`}
      style={{ height: props.height, width: props.width }}
      aria-hidden="true"
    />
  );
}
